import { g as A, m as P, s as B } from "../arrays-fVhvTJ84.js";
import { identity as l } from "../functions/index.js";
function v(t, i) {
  const f = {};
  for (const n in t) {
    const o = i(t[n], n, t), r = f[o] || {};
    r[n] = t[n], f[o] = r;
  }
  return f;
}
function p(t, i, f) {
  if (i(t))
    return t;
  if (t[f]) {
    for (const n of t[f])
      if (i(n))
        return n;
    for (const n of t[f]) {
      const o = p(n, i, f);
      if (o !== void 0)
        return o;
    }
  }
}
function m(t, i, f) {
  if (i(t))
    return [t];
  if (t[f]) {
    for (const n of t[f])
      if (i(n))
        return [t, n];
    for (const n of t[f]) {
      const o = m(n, i, f);
      if (o !== void 0)
        return [t].concat(o);
    }
  }
}
function T(t, i, f) {
  const n = [];
  if (i(t) && n.push(t), t[f])
    for (const o of t[f]) {
      const r = T(o, i, f);
      for (const s of r)
        n.push(s);
    }
  return n;
}
function h(t, i, f, n) {
  const o = i(t);
  if (o === null)
    return null;
  const r = o;
  if (t[f] != null) {
    const s = t[f].map((c) => h(c, i, f, n)).filter((c) => c !== null);
    s.length > 0 && (r[n ?? f] = s);
  }
  return r;
}
function u(t, i, f, n = []) {
  const o = [i(t, n)];
  if (t[f]) {
    const r = n.concat([t]);
    for (const s of t[f]) {
      const c = u(s, i, f, r);
      for (const a of c)
        o.push(a);
    }
  }
  return o;
}
function I(t, i) {
  return u(t, l, i);
}
function M(t, i) {
  return [t, i];
}
export {
  p as findInTree,
  T as findManyInTree,
  m as findPathInTree,
  u as flattenMapTree,
  I as flattenTree,
  A as groupBy,
  P as mapArrayLike,
  h as mapTree,
  M as pair,
  v as partition,
  B as splitAt
};
//# sourceMappingURL=index.js.map
